import { apiService } from './api'
import { Category, CategoryFormData } from '../types'

export class CategoryService {
  async getCategories(type?: 'income' | 'expense' | 'both'): Promise<Category[]> {
    const params = type ? { type } : {}
    const response = await apiService.get<Category[]>('/categories', params)
    return response
  }

  async getCategory(id: number): Promise<Category> {
    const response = await apiService.get<Category>(`/categories/${id}`)
    return response
  }

  async createCategory(data: CategoryFormData): Promise<Category> {
    const response = await apiService.post<Category>('/categories', data)
    return response
  }

  async updateCategory(id: number, data: Partial<CategoryFormData>): Promise<Category> {
    const response = await apiService.put<Category>(`/categories/${id}`, data)
    return response
  }

  async deleteCategory(id: number): Promise<void> {
    return apiService.delete<void>(`/categories/${id}`)
  }

  async searchCategories(query: string): Promise<Category[]> {
    const response = await apiService.get<Category[]>('/categories/search', { q: query })
    return response
  }

  async getIncomeCategories(): Promise<Category[]> {
    return this.getCategories('income')
  }

  async getExpenseCategories(): Promise<Category[]> {
    return this.getCategories('expense')
  }
}

export const categoryService = new CategoryService()